<div class="content-container px-4">
    <h2 class="text-xl font-bold text-gray-800 dark:text-white my-4">
        Histórico de Actividad de Operarios
    </h2>

    <!-- Filters -->
    <div class="flex gap-2 mb-4">
        <!-- Search Input -->
        <nz-input-group
            [nzPrefix]="searchIcon"
            [nzSuffix]="clearSearchInput"
            class="rounded-lg border border-gray-300"
            style="width: 250px"
        >
            <input
                onfocus="select()"
                class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Nombre"
                nz-input
                [(ngModel)]="userFilter"
                (ngModelChange)="onFilterChange()"
            />
        </nz-input-group>
        <ng-template #clearSearchInput>
            @if (userFilter) {
                <span
                    class="ant-input-clear-icon"
                    nzTheme="fill"
                    nzType="close-circle"
                    (click)="clearUserFilter()"
                    nz-icon
                ></span>
            }
        </ng-template>
        <ng-template #searchIcon>
            <span nz-icon nzType="search"></span>
        </ng-template>

        <!-- Date Picker StartDate -->
        <nz-input-group
            [nzPrefix]="startDateSpan"
            class="rounded-lg border border-gray-300"
            style="width: 250px"
        >
            <input
                id="startDateFilter"
                nz-input
                class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                type="datetime-local"
                [(ngModel)]="startDateFilter"
                (ngModelChange)="onFilterChange()"
            />
        </nz-input-group>
        <ng-template #startDateSpan>
            <span>Desde -</span>
        </ng-template>

        <!-- Date Picker EndDate -->
        <nz-input-group
            [nzPrefix]="endDateSpan"
            class="rounded-lg border border-gray-300"
            style="width: 250px"
        >
            <input
                id="endDateFilter"
                nz-input
                class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                type="datetime-local"
                [(ngModel)]="endDateFilter"
                (ngModelChange)="onFilterChange()"
            />
        </nz-input-group>
        <ng-template #endDateSpan>
            <span>Hasta -</span>
        </ng-template>
    </div>

    <!-- Table -->
    <nz-table
        [nzPageSize]="pageSize()"
        [(nzPageIndex)]="currentPage"
        [nzPageSizeOptions]="[2, 5, 7, 10]"
        nzShowSizeChanger
        [nzFrontPagination]="false"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzData]="usersActivityHistoryFiltered"
        nzBordered
        [nzLoading]="isLoading"
        [nzTotal]="totalUsers()"
        [nzSize]="'small'"
        [nzScroll]="{ x: '1000px' }"
    >
        <thead>
            <tr>
                <th>Trabajador</th>
                <th>Rol</th>
                <th>Nº Pausas Realizadas</th>
                <th>Nº Pausas Reanudadas</th>
                <th>Nº Procesos Iniciados</th>
                <th>Nº Procesos Finalizados</th>
                <th>Nº Procesos Completados</th>
                <th>Nº Mermas Realizadas</th>
            </tr>
        </thead>
        <tbody>
            @for (
                userActivityHistory of usersActivityHistoryFiltered;
                track userActivityHistory.user.id
            ) {
                <tr>
                    <td>{{ userActivityHistory.user.name }}</td>
                    <td>{{ userActivityHistory.user.profile?.name }}</td>
                    <td>{{ userActivityHistory.totalPausesStarted }}</td>
                    <td>{{ userActivityHistory.totalPausesFinished }}</td>
                    <td>{{ userActivityHistory.totalProcessesStarted }}</td>
                    <td>{{ userActivityHistory.totalProcessesFinished }}</td>
                    <td>{{ userActivityHistory.totalProcessesCompleted }}</td>
                    <td>{{ userActivityHistory.totalLosses }}</td>
                </tr>
            }
        </tbody>
    </nz-table>
</div>
